export interface ArenaObstacle {
  x: number;
  z: number;
  hx: number;
  hz: number;
  rotY: number;
  height: number;
}

export const ARENA_OBSTACLES: ArenaObstacle[] = [
  // Central zone (within ~30 m of centre)
  { x:   0, z:   0, hx: 6,   hz: 0.8, rotY: 0,     height: 1.6 },
  { x:  22, z: -18, hx: 3,   hz: 1.5, rotY: -0.4,  height: 2.0 },
  { x: -25, z:  15, hx: 4,   hz: 1.2, rotY:  0.3,  height: 2.4 },
  { x:  10, z:  25, hx: 1.5, hz: 4,   rotY:  0.15, height: 2.0 },
  { x: -12, z: -22, hx: 1.8, hz: 1.8, rotY:  0.4,  height: 3.0 },
  // Mid-ring (30–65 m)
  { x: -48, z: -22, hx: 4,   hz: 1.2, rotY:  0.3,  height: 2.4 },
  { x:  42, z:  32, hx: 3,   hz: 1.5, rotY: -0.4,  height: 2.0 },
  { x: -40, z:  55, hx: 5,   hz: 1.0, rotY:  1.2,  height: 1.4 },
  { x:  55, z: -15, hx: 1.2, hz: 4,   rotY:  0.0,  height: 2.2 },
  { x:  60, z: -55, hx: 2.4, hz: 2.4, rotY:  0.78, height: 2.8 },
  { x: -65, z:  30, hx: 2,   hz: 2,   rotY:  0.0,  height: 3.2 },
  { x: -18, z:  65, hx: 4.5, hz: 1.0, rotY:  0.5,  height: 2.2 },
  { x:  35, z: -55, hx: 2.0, hz: 3.0, rotY:  0.2,  height: 2.6 },
  { x: -55, z: -40, hx: 1.8, hz: 1.8, rotY:  0.0,  height: 4.0 },
  { x:  30, z:  60, hx: 1.5, hz: 3.5, rotY: -0.3,  height: 2.4 },
  // Outer ring (65–100 m, ≥26 m from nearest spawn)
  { x:  85, z:  40, hx: 1.0, hz: 4.5, rotY:  0.1,  height: 2.2 },
  { x: -85, z: -30, hx: 4.5, hz: 1.0, rotY:  0.2,  height: 1.8 },
  { x:  45, z: -90, hx: 2.5, hz: 1.5, rotY:  0.4,  height: 2.4 },
  { x: -45, z:  85, hx: 1.5, hz: 2.5, rotY:  0.7,  height: 2.2 },
  { x: -90, z:  50, hx: 1.0, hz: 3.5, rotY:  0.0,  height: 2.8 },
  { x:  90, z: -50, hx: 3.5, hz: 1.0, rotY:  0.15, height: 2.0 },
  { x: -60, z:  75, hx: 2.0, hz: 2.0, rotY:  0.5,  height: 3.2 },
  { x:  75, z:  60, hx: 3.0, hz: 1.5, rotY:  0.6,  height: 2.6 },
  { x: -75, z: -65, hx: 1.5, hz: 3.0, rotY: -0.4,  height: 2.2 },
];
